<template>
  <div class="chart_SQL">
    <div class="chart-bottom">
      <!-- 左侧选择栏 -->
      <!-- <div class="result">Empty result.</div> -->
      <div style="padding-right: 10px;border-right: 1px solid #E5E7EB;">
        <!-- <div> -->
        <!-- <div class="top"> -->
        <!-- <div class="right"> -->
        <!-- <Button>
          <Icon type="md-list" />Bar chart <Icon type="md-arrow-dropdown"
        /></Button> -->
        <Select
          v-model="selectedChartType"
          style="width: 150px"
          prefix="md-list"
          @on-change="handleChangeType"
        >
          <Option
            v-for="item in chartTypeList"
            :value="item.value"
            :key="item.value"
            ><Icon :type="item.type" /> {{ item.label }}</Option
          >
        </Select>
        <div v-if="selectedChartType == 'Bar Chart'" class="chart-bottom-left">
          <p>X轴</p>
          <Select v-model="barData.barXaxis" transfer>
            <Option
              v-for="(item, index) in barColumnX"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
          <p>Y轴</p>
          <ul v-if="showCheck">
            <li
              v-for="(item, index) in barCheckboxGroup"
              :key="index"
              style="margin-top: 20px"
            >
              <input
                type="checkbox"
                v-model="barCheckbox"
                :value="item"
                @click="choose(index, item)"
              />
              <span>{{ item }} </span>
            </li>
          </ul>
          <Select
            v-else
            v-model="barData.barYaxis"
            style="width: 200px"
            transfer
          >
            <Option
              v-for="(item, index) in barColumnY"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>

          <p>组</p>
          <Select v-model="barData.barGroup">
            <Option v-for="(item, index) in group" :key="index" :value="item">{{
              item
            }}</Option>
          </Select>
          <p>限制</p>
          <Select v-model="limitNnm">
            <Option
              v-for="(item, index) in limit"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}</Option
            >
          </Select>
          <p>排序</p>
          <div>
            <Button
              v-for="(i, index) in icon"
              :key="index"
              :class="sortIndex == index ? 'sort' : ''"
              @click="barSort(index)"
            >
              <Icon :custom="i" size="20" />
            </Button>
          </div>
        </div>
        <!-- 饼图 -->
        <div v-if="selectedChartType == 'pin Chart'" class="chart-bottom-left">
          <p>值</p>
          <!-- 有数据 -->
          <Select v-model="pinData.value" transfer>
            <Option
              v-for="(item, index) in barColumnX"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
          <p>图例</p>
          <!-- 全部 -->
          <Select v-model="pinData.legend" transfer>
            <Option
              v-for="(item, index) in barColumnX"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
          <p>限制</p>
          <Select v-model="limitNnm">
            <Option
              v-for="(item, index) in limit"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}</Option
            >
          </Select>
          <p>排序</p>
          <div>
            <Button
              class="aa"
              v-for="(i, index) in icon"
              :key="index"
              :class="sortIndex == index ? 'sort' : ''"
              @click="barSort(index)"
            >
              <Icon :custom="i" size="20" />
            </Button>
          </div>
        </div>
        <!-- 散点 -->
        <div
          v-if="selectedChartType == 'Scatter Plot'"
          class="chart-bottom-left"
        >
          <p>X轴</p>
          <Select v-model="scaData.barXaxis" transfer>
            <Option
              v-for="(item, index) in barColumnX"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
          <p>Y轴</p>
          <Select v-model="scaData.barYaxis" style="width: 200px" transfer>
            <Option
              v-for="(item, index) in barColumnY"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
          <p>限制</p>
          <Select v-model="limitNnm">
            <Option
              v-for="(item, index) in limit"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}</Option
            >
          </Select>
          <p>散点图大小</p>
          <Select v-model="scaData.size" transfer>
            <Option
              v-for="(item, index) in barColumnX"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
          <p>散点图组</p>
          <Select v-model="scaData.scaGroup" transfer>
            <Option
              v-for="(item, index) in barColumnX"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
        </div>
      </div>
      <!-- 图表展示 -->
      <div class="chart-bottom-right">
        <div v-if="hasData">
          <div
            v-show="chartShow"
            id="charts"
            :style="{ width: '600px', height: '360px' }"
          ></div>
          <h1 v-show="!chartShow" class="empty">选择左边的图表参数</h1>
        </div>
        <h1 v-else class="empty">没有可用数据</h1>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      menu: true,
      chartShow: false, //是否选择数据
      hasData: true, //是否有数据
      showCheck: true, //Y切换下拉和单选
      // bar
      barColumnX: ["choose a column..."],
      barColumnY: ["choose a column..."],
      group: ["choose a column to pivot..."],
      barCheckboxGroup: [],
      limit: [
        {
          value: "number",
          label: "Limit the number of results to...",
        },
        { value: "5", label: "5" },
        { value: "10", label: "10" },
        { value: "25", label: "25" },
        { value: "50", label: "50" },
        { value: "100", label: "100" },
      ],
      limitNnm: "number",
      icon: [
        "i-custom icon-sort1",
        "i-custom icon-sort_up",
        "i-custom icon-sort_down",
      ],
      sortIndex: 0,
      // bar
      // barChangeType: "",
      barCheckbox: [],
      barData: {
        changeType: "bars",
        barXaxis: "choose a column...",
        barYaxis: "choose a column...",
        barGroup: "choose a column to pivot...",
      },

      dataX: [], //柱状图X
      barSeries: [], //柱状图series
      barLegend: [], //柱状图legend

      // pin
      pinData: {
        value: "choose a column...",
        legend: "choose a column...",
      },
      PinSeriesData: [], //饼图数据

      // scatter
      scaData: {
        barXaxis: "choose a column...",
        barYaxis: "choose a column...",
        size: "choose a column...",
        scaGroup: "choose a column...",
      },
      scaSeriesData: [], //散点数据
      legendData: [], //散点legend
      // ------------

      selectedChartType: "Bar Chart", //切换不同类型图表
      chartTypeList: [
        { value: "Bar Chart", label: "Bar Chart", type: "md-barcode" }, //条形
        { value: "pin Chart", label: "pin Chart", type: "md-baseball" }, //饼图
        { value: "Scatter Plot", label: "Scatter Plot", type: "md-cog" }, //散点
      ], //图表类型
      // chartData: {
      // execute: {
      //   keys: ["goods_price", "aaaa", "bbb", "ee"],
      //   values: [
      //     ["200", "300", "400", "aa"],
      //     ["400", "222", "100", "bb"],
      //     ["100", "400", "200", "cc"],
      //     ["400", "200", "300", "vv"],
      //     [null, null, "55", "aa"],
      //   ],
      // },
      chartData: {},
      setSeriesDta: [], //已处理可直接使用数据
      option: {},
      chartDataArr: [],
      inverse: false,
    };
  },
  props: {
    execute: Object, //查询数据
  },
  created() {},
  components: {},
  computed: {},
  mounted() {
    // this.executeaa(this.execute);
    // console.log(this.execute, 111);
    this.initExecute(this.execute);
  },
  watch: {
    // 切换不同类型图表
    selectedChartType() {
      this.sortIndex = 0;
      this.drawLine();
    },
    execute(execute) {
      // console.log(execute, "222");
      this.initExecute(execute);
    },
    chartDataArr(execute) {
      // console.log(execute, "222");
      this.initExecute(execute);
    },
    // 选择X 切换 this.dataX
    "barData.barXaxis"(val) {
      let barXIndex = this.chartData.keys.indexOf(val); // barXaxis数据选择

      this.dataX = [];
      this.chartData.values.forEach((subItem, subIndex) => {
        barXIndex == -1
          ? this.dataX.push(subIndex + 1)
          : this.dataX.push(subItem[barXIndex]);
      });
      this.updateShow();
    },
    "barData.barYaxis"(val) {
      let barYIndex = this.chartData.keys.indexOf(val); // barYaxis数据选择
      this.changeChart(barYIndex);
    },
    "barData.barGroup"(val) {
      let barXIndex = this.chartData.keys.indexOf(this.barData.barXaxis); // barXaxis数据选择
      let barYIndex = this.chartData.keys.indexOf(this.barData.barYaxis); // barYaxis数据选择
      let groupIndex = this.chartData.keys.indexOf(val); // barGroup数据选择

      if (groupIndex == -1) {
        this.barSeries = []; //11
        this.showCheck = true;
        this.barLegend = this.chartData.keys;
        let date = [];

        this.chartData.keys.forEach((subItem, subIndex) => {
          date = [];

          this.chartData.values.forEach((item, index) => {
            date.push(item[subIndex]);
          });
          let obj = {
            name: subItem,
            data: date,
            type: "bar",
          };
          this.barSeries.push(obj);
        });
        this.updateShow();
      } else {
        this.showCheck = false;
        this.barLegend = []; //11
        this.changeChart(barYIndex);
      }
    },

    pinData: {
      handler: function () {
        let legIndex = this.chartData.keys.indexOf(this.pinData.legend); // value数据选择
        let valIndex = this.chartData.keys.indexOf(this.pinData.value); // legend数据选择

        this.PinSeriesData = [];

        this.chartData.values.forEach((subitem, subindex) => {
          this.PinSeriesData.push({
            value: valIndex == -1 ? subindex + 1 : subitem[valIndex],
            name: legIndex == -1 ? subindex + 1 : subitem[legIndex],
          });
        });
        this.chartShow = true;
        this.drawLine();
      },
      deep: true,
    },

    scaData: {
      handler: function () {
        let Xindex = this.chartData.keys.indexOf(this.scaData.barXaxis); //X轴数据选择  0
        let Yindex = this.chartData.keys.indexOf(this.scaData.barYaxis); //Y轴数据选择  1
        let sizeIndex = this.chartData.keys.indexOf(this.scaData.size); //size数据选择
        let scaGroupIndex = this.chartData.keys.indexOf(this.scaData.scaGroup); //scaGroup数据选择

        this.scaSeriesData = [];
        this.legendData = [];

        this.chartData.values.forEach((subItem, subIndex) => {
          this.scaSeriesData.push({
            data: [
              [
                Xindex == -1 ? subIndex + 1 : subItem[Xindex],
                Yindex == -1 ? subIndex + 1 : subItem[Yindex],
              ],
            ],
            type: "scatter",
            name: scaGroupIndex == -1 ? subIndex + 1 : subItem[scaGroupIndex],
            symbolSize:
              sizeIndex == -1 ? 10 : Math.sqrt(Math.sqrt(subItem[sizeIndex])),
          });
          this.legendData.push(
            scaGroupIndex == -1 ? String(subIndex + 1) : subItem[scaGroupIndex]
          );
        });
        this.chartShow = true;
        this.drawLine();
      },
      deep: true,
    },
    limitNnm(val) {
      let chartDataArr = [];
      if (val == "number") {
        chartDataArr = this.execute;
      } else {
        chartDataArr.keys = this.execute.keys;
        let data = this.execute.values.filter((item, index) => {
          if (index < val) {
            return item;
          }
        });
        chartDataArr.values = data;
      }
      this.initExecute(chartDataArr);
      // this.drawLine();
    },
  },
  methods: {
    handleChangeType() {},
    updateShow() {
      this.chartShow = true;
      this.drawLine();
    },
    initExecute(chartData) {
      console.log(chartData, "chartData");
      if (chartData.keys) {
        this.chartData = chartData;

        this.barColumnX = ["choose a column..."];
        this.barColumnY = ["choose a column..."];
        this.group = ["choose a column to pivot..."];
        this.barCheckboxGroup = [];

        this.dataX = [];
        let date = [];

        // bar
        this.barSeries = [];

        this.barLegend = this.chartData.keys;

        this.chartData.values.forEach((item, index) => {
          this.dataX.push(index + 1);
        });

        this.chartData.keys.forEach((subItem, subIndex) => {
          date = [];
          this.barColumnX.push(subItem);
          this.barColumnY.push(subItem);
          this.barCheckboxGroup.push(subItem);
          this.group.push(subItem);
          // 默认选中第一项
          if (subIndex == 0) {
            this.barCheckbox.push(subItem);
          }
          this.chartData.values.forEach((item, index) => {
            date.push(item[subIndex]);
          });
          let obj = {
            name: subItem,
            data: date,
            type: "bar",
          };
          this.barSeries.push(obj);
        });
        this.PinSeriesData = [];
        // pin
        this.chartData.values.forEach((item) => {
          this.PinSeriesData.push({ value: item[0], name: item[0] });
        });
        this.legendData = [];
        this.scaSeriesData = [];
        // sca
        this.chartData.values.forEach((item, index) => {
          this.scaSeriesData.push({
            symbolSize: 20,
            data: [[index + 1, index + 1]],
            name: index + 1,
            type: "scatter",
          });
          this.legendData.push(String(index + 1));
        });
      } else {
        this.chartData = {};
      }
      this.drawLine();
    },

    // 柱状图Y单选
    choose(index) {
      var myChart = echarts.init(document.getElementById("charts"), 'myCustomTheme');
      if (this.option.legend) {
        var data = this.option.legend.data;
        let optionItem = this.option.legend.selected[data[index]];
        // selected 最开始只有selected=true 不存在其他变量  所以未undefind
        optionItem == undefined || optionItem == true
          ? (this.option.legend.selected[data[index]] = false)
          : (this.option.legend.selected[data[index]] = true);

        myChart.setOption(this.option);
      }
    },

    changeChart(barYIndex) {
      let date = [];
      if (barYIndex == -1) {
        this.barSeries = [];
        this.chartData.values.forEach((subItem, subIndex) => {
          date = new Array(subItem.length).fill(0);
          date[subIndex] = subIndex + 1;
          let obj = {
            data: date,
            type: "bar",
          };
          this.barSeries.push(obj);
        });
      } else {
        this.barSeries = [];
        this.chartData.values.forEach((subItem, subIndex) => {
          date = new Array(subItem.length).fill(0);
          date[subIndex] = subItem[barYIndex];
          let obj = {
            data: date,
            type: "bar",
          };
          this.barSeries.push(obj);
        });
      }
      this.updateShow();
    },
    // 排序
    barSort(index) {
      this.sortIndex = index;

      if (this.selectedChartType == "Bar Chart") {
        if (index == 0) {
          // 顺序
          this.inverse = false;
        } else if (index == 1) {
          // 正序
          this.inverse = false;
        } else {
          // 倒叙
          this.inverse = true;
        }
      } else if (this.selectedChartType == "pin Chart") {
        if (index == 0) {
          // 顺序
          this.PinSeriesData.sort((a, b) => a.value - b.value);
        } else if (index == 1) {
          // 正序
          this.PinSeriesData.sort((a, b) => a.value - b.value);
        } else {
          // 倒叙
          this.PinSeriesData.sort((a, b) => b.value - a.value);
        }
      }

      this.updateShow();
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let Plot = echarts.init(document.getElementById("charts"), 'myCustomTheme');

      if (this.selectedChartType == "Bar Chart") {
        // 柱状图

        this.option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          legend: {
            selected: {},
            data: this.barLegend,
          },
          xAxis: {
            type: "category",
            data: this.dataX, //2
            inverse: this.inverse, //排序  true 倒叙 false 正序
          },
          yAxis: {
            type: "value",
          },
          series: this.barSeries,
        };
        // 绑定点击
        for (var i = 0; i < this.option.series.length; i++) {
          if (i == 0) {
            this.option.legend.selected[this.option.series[i].name] = true;
          } else {
            this.option.legend.selected[this.option.series[i].name] = false;
          }
        }
      } else if (this.selectedChartType == "pin Chart") {
        // 饼图
        this.option = {
          tooltip: {
            trigger: "item",
          },
          series: [
            {
              name: "Access From",
              type: "pie",
              radius: "50%",
              data: this.PinSeriesData,
            },
          ],
        };
      } else if (this.selectedChartType == "Scatter Plot") {
        // 散点图
        this.option = {
          tooltip: {
            position: "top",
          },
          xAxis: {},
          yAxis: {},
          legend: {
            data: this.legendData,
          },
          series: this.scaSeriesData,
        };
      }

      // 绘制图表
      Plot.clear();
      Plot.setOption(this.option);
      Plot.resize();
    },
  },
};
</script>

<style scoped>
.chart_SQL {
  padding: 0 30px 0 10px;
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right Button {
  color: #0084FF;
  margin-right: 12px;
}
.result {
  font-size: 30px;
  color: #d6d8db;
  display: flex;
  margin-top: 30px;
  justify-content: center;
}
.chart-bottom {
  display: flex;
  height: 100%;
  gap: 15px;
}
.chart-bottom-left {
  padding: 10px 0;
}
.chart-bottom-left p {
  margin-top: 12px;
}
.chart-bottom-right {
  flex: 1;
  height: 100%;
  padding: 10px;
}

.empty {
  margin-top: 50px;
  text-align: center;
  color: #d6d8db;
  font-weight: normal;
  line-height: 48px;
}
.sort {
  color: #29a7e0;
  border: 1px solid #29a7de;
}
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/chart.vue